import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { useState, useRef, forwardRef } from 'react';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import { useClickOutside } from '../../hooks/clickOutside.js';
import { Stack } from '../../layouts/Stack/Stack.js';
import { Switch } from '../Switch/Switch.js';
import style from './Menu.module.css.js';

const Menu = ({ children, className, activator, matchActivatorWidth, onOpen, onClose, onClick, dropdownPosition = "right", }) => {
    const [open, setOpen] = useState(false);
    const clickOutsideTarget = useRef(null);
    useClickOutside(clickOutsideTarget.current, () => {
        setOpen(false);
        if (open)
            onClose?.();
    });
    return (jsxs("div", { ref: clickOutsideTarget, className: classNames(style.menuWrapper, className), children: [React__default.cloneElement(activator, {
                onClick: (event) => {
                    open ? onClose?.() : onOpen?.();
                    setOpen(!open);
                    activator.props.onClick?.(event);
                },
            }), jsx("div", { role: "menu", className: classNames(style.dropdownWrapper, open && style.open), onClick: onClick, children: jsx(Stack, { className: classNames(style.menu, dropdownPosition === "right" ? style.right : style.left, matchActivatorWidth && style.fullWidth), direction: "column", children: React__default.Children.map(children, (child) => {
                        if (child && React__default.isValidElement(child) && child.props.closeOnClick) {
                            const c = child;
                            return React__default.cloneElement(c, {
                                onClick: (event) => {
                                    open ? onClose?.() : onOpen?.();
                                    setOpen(!open);
                                    c.props.onClick?.(event);
                                },
                            });
                        }
                        return child;
                    }) }) })] }));
};
const MenuItem = ({ children, disabled, onClick }) => {
    return (jsx("button", { role: "menuitem", className: classNames(style.menuItem), disabled: disabled, onClick: (event) => onClick?.(event), children: children }));
};
Menu.Item = MenuItem;
const MenuLink = ({ children, closeOnClick: _, ...attrs }) => {
    return (jsx("a", { role: "menuitem", ...attrs, className: classNames(style.menuItem), children: children }));
};
Menu.Link = MenuLink;
const MenuDivider = () => {
    return jsx("hr", { role: "separator", className: style.menuDivider });
};
Menu.Divider = MenuDivider;
const MenuToggle = forwardRef(({ children, className, closeOnClick: _, ...attrs }, ref) => {
    return (jsxs("label", { role: "menuitemcheckbox", className: classNames(style.menuToggle, style.menuItem, attrs.disabled && style.disabled, className), children: [children, jsx(Switch, { ...attrs, ref: ref })] }));
});
MenuToggle.displayName = "MenuToggle";
Menu.Toggle = MenuToggle;

export { Menu };
//# sourceMappingURL=Menu.js.map
